import ActionHelper from '@module/redux-actions';

export const actions = ActionHelper.types([
  'ROUTE_SET',
  'ROUTE_SET_FORMSTATE',
  'ROUTE_SET_NEXT_ACTION',
]);

export default ActionHelper.generate({
  setRoute: [actions.ROUTE_SET, 'route'],
  setFormState: [actions.ROUTE_SET_FORMSTATE, 'formState'],
  setNextAction: [actions.ROUTE_SET_NEXT_ACTION, 'routeAction'],
});
